import type {
  iOrganizationEmailConfig,
  QuoteEmailDeliveryMethod,
} from "./brand-model";

export const QUOTE_EMAIL_DELIVERY_METHODS: QuoteEmailDeliveryMethod[] = [
  "CUSTOM_SMTP",
  "BOOKING_EMAIL_DOMAIN",
  "CUSTOM_EMAIL_DOMAIN",
];

export const DEFAULT_QUOTE_EMAIL_DELIVERY_METHOD: QuoteEmailDeliveryMethod =
  "CUSTOM_SMTP";

export function resolveQuoteEmailDeliveryMethod(
  emailConfig?: Pick<iOrganizationEmailConfig, "deliveryMethod"> | null
): QuoteEmailDeliveryMethod {
  const method = emailConfig?.deliveryMethod;
  if (method && isQuoteEmailDeliveryMethod(method)) {
    return method;
  }
  return DEFAULT_QUOTE_EMAIL_DELIVERY_METHOD;
}

export function isQuoteEmailDeliveryMethod(
  value: unknown
): value is QuoteEmailDeliveryMethod {
  return (
    typeof value === "string" &&
    (QUOTE_EMAIL_DELIVERY_METHODS as readonly string[]).includes(value)
  );
}

export type ResolvedOrganizationEmailConfig = iOrganizationEmailConfig & {
  deliveryMethod: QuoteEmailDeliveryMethod;
};

/** Returns email config with a guaranteed delivery method (legacy-safe). */
export function resolveOrganizationEmailConfig(
  emailConfig?: iOrganizationEmailConfig | null
): ResolvedOrganizationEmailConfig {
  return {
    ...(emailConfig ?? {}),
    deliveryMethod: resolveQuoteEmailDeliveryMethod(emailConfig),
  };
}
